module.exports = __webpack_public_path__ + "img/icb-leo-elite-m@3x.95d2754b.png";